var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 12 12.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#39af4f;}.cls-5{stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 12,
    height: 12.01
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.76,0A6,6,0,1,0,12,6.36V5.63A6,6,0,0,0,6.27,0Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -4.99,
    y: -5.01,
    width: 22,
    height: 22
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 3.15,
    y1: 5.99,
    x2: 8.88,
    y2: 5.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 6.01,
    y1: 2.99,
    x2: 6.01,
    y2: 8.99
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenPlus);
export default __webpack_public_path__ + "static/media/green-plus.412659f0856f2324bd848a00fa72fc9f.svg";
export { ForwardRef as ReactComponent };